// extracted by mini-css-extract-plugin
var _1 = "DocFlowFileOverlay-moduleDocFlowFileOverlay__LXVQX FilePreviewOverlay-moduleFilePreviewOverlay__vJvIV";
var _2 = "DocFlowFileOverlay-moduleactive__t5F1F";
var _3 = "DocFlowFileOverlay-moduledisabled__oj2_S";
var _4 = "DocFlowFileOverlay-moduleicon__ItzN8 FilePreviewOverlay-moduleicon__E45rA";
export { _1 as "DocFlowFileOverlay", _2 as "active", _3 as "disabled", _4 as "icon" }
